<template>
  <v-card tile :color="config.background">
    <v-toolbar :dark="config.dark_primary" :color="config.primary">
      <slot name=actions>
      </slot>
        <v-btn class="ml-2" icon @click="prepPrint()">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn class="ml-2" :loading="loading" text outlined @click="startPrint()">Print</v-btn>
      <v-toolbar-items>
      </v-toolbar-items>
    </v-toolbar>
    <div class="flex-container">
      <div id="left-side">
        <canvas id="p"></canvas>
      </div>
      <div id="right-side">
        <v-card flat tile>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-overflow-btn
                  class="my-2"
                  :items="configs"
                  label="Presets"
                  editable
                  v-model="currentConfig"
                  :spellcheck="false"
                  :item-color="config.secondary"
                ></v-overflow-btn>
                <v-row justify="center" class="mb-5 mt-5 ml-5 mr-5">
                  <v-btn tile :color="config.secondary" :dark="config.dark_secondary" large @click="toggleHalf('top')" block>
                    <span>
                      <h3>Select Top Half</h3>
                    </span>
                  </v-btn>
                </v-row>
                <v-row justify="center" class="mb-5 mt-5 ml-5 mr-5">
                  <v-btn tile :color="config.secondary" :dark="config.dark_secondary" large @click="toggleHalf('bottom')" block>
                    <span>
                      <h3>Select Bottom Half</h3>
                    </span>
                  </v-btn>
                </v-row>
                <v-row justify="center" class="mb-5 mt-5 ml-5 mr-5">
                  <v-btn tile :color="config.secondary" :dark="config.dark_secondary" large @click="toggleHalf('all')" block>
                    <span>
                      <h3>Select All</h3>
                    </span>
                  </v-btn>
                </v-row>
                <v-row justify="center" class="mb-5 mt-5 ml-5 mr-5">
                  <v-btn tile :color="config.secondary" :dark="config.dark_secondary" large @click="toggleHalf('none')" block>
                    <span>
                      <h3>Select None</h3>
                    </span>
                  </v-btn>
                </v-row>
                <v-row justify="center" class="mb-5 mt-5 ml-5 mr-5">
                  <v-btn tile :loading="loading" :color="config.primary" :dark="config.dark_primary" large @click="startPrint()" block>
                    <span>
                      <h3>Print</h3>
                    </span>
                  </v-btn>
                </v-row>
                <v-row justify="center" class="mb-5 mt-5 ml-5 mr-5 text-center">
                  <h3 class="mt-1">Quick Adjust</h3>
                  <v-btn @click="resetAdjust()" class="ml-3" icon :color="config.primary">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </v-row>
                <v-row justify="center" class="mb-5 mt-5 ml-5 mr-5">
                  <div class="button-container-main">
                    <div class="button-item">
                      <v-btn icon @click="settings.offsetX += 0.01, prepPrint()">
                        <v-icon>mdi-arrow-left</v-icon>
                      </v-btn>
                    </div>
                    <span class="button-name">{{this.settings.offsetX.toFixed(4)}}</span>
                    <div class="button-item">
                      <v-btn icon @click="settings.offsetX -= 0.01, prepPrint()">
                        <v-icon>mdi-arrow-right</v-icon>
                      </v-btn>
                    </div>
                    <span class="button-name">Offset X</span>
                  </div>
                  <div class="button-container-main">
                    <div class="button-item">
                      <v-btn icon @click="settings.offsetY += 0.01, prepPrint()">
                        <v-icon>mdi-arrow-up</v-icon>
                      </v-btn>
                    </div>
                    <span class="button-name">{{this.settings.offsetY.toFixed(4)}}</span>
                    <div class="button-item">
                      <v-btn icon @click="settings.offsetY -= 0.01, prepPrint()">
                        <v-icon>mdi-arrow-down</v-icon>
                      </v-btn>
                    </div>
                    <span class="button-name">Offset Y</span>
                  </div>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6">
                <v-list dark class="list-inside">
                  <v-list-group
                  prepend-icon="mdi-cog"
                  v-model="advancedList"
                  @click="printList = false"
                  :style="'background-color:'+config.secondary"
                  :color="config.secondary_text"
                  >
                    <template v-slot:activator>
                      <v-list-item-title>Advanced</v-list-item-title>
                    </template>
                    <v-list-group
                      no-action
                      sub-group
                      v-model="guideList"
                      @click="chipList = false"
                      :color="config.primary_text"
                    >
                      <template v-slot:activator>
                        <v-list-item-title>Guide Adjustment</v-list-item-title>
                      </template>
                      <div class="button-container">
                        <div class="button-item">
                          <v-btn icon @click="settings.outlineOffsetX -= 1, prepPrint()">
                            <v-icon>mdi-arrow-left</v-icon>
                          </v-btn>
                        </div>
                        <span class="button-name">{{this.settings.outlineOffsetX.toFixed(2)}}</span>
                        <div class="button-item">
                          <v-btn icon @click="settings.outlineOffsetX += 1, prepPrint()">
                            <v-icon>mdi-arrow-right</v-icon>
                          </v-btn>
                        </div>
                        <span class="button-name">Offset X</span>
                      </div>
                      <div class="button-container">
                        <div class="button-item">
                          <v-btn icon @click="settings.outlineOffsetY += 1, prepPrint()">
                            <v-icon>mdi-arrow-up</v-icon>
                          </v-btn>
                        </div>
                        <span class="button-name">{{this.settings.outlineOffsetY.toFixed(2)}}</span>
                        <div class="button-item">
                          <v-btn icon @click="settings.outlineOffsetY -= 1, prepPrint()">
                            <v-icon>mdi-arrow-down</v-icon>
                          </v-btn>
                        </div>
                        <span class="button-name">Offset Y</span>
                      </div>
                      <div class="button-container">
                        <div class="button-item">
                          <v-btn icon @click="settings.outlineScale += 0.003, prepPrint()">
                            <v-icon>mdi-arrow-up</v-icon>
                          </v-btn>
                        </div>
                        <span class="button-name">{{this.settings.outlineScale.toFixed(4)}}</span>
                        <div class="button-item">
                          <v-btn icon @click="settings.outlineScale -= 0.003, prepPrint()">
                            <v-icon>mdi-arrow-down</v-icon>
                          </v-btn>
                        </div>
                        <span class="button-name">Scale All</span>
                      </div>
                      <div class="button-container">
                        <div class="button-item">
                          <v-btn icon @click="settings.outlineScaleX -= 0.005, prepPrint()">
                            <v-icon>mdi-arrow-left</v-icon>
                          </v-btn>
                        </div>
                        <span class="button-name">{{this.settings.outlineScaleX.toFixed(4)}}</span>
                        <div class="button-item">
                          <v-btn icon @click="settings.outlineScaleX += 0.005, prepPrint()">
                            <v-icon>mdi-arrow-right</v-icon>
                          </v-btn>
                        </div>
                        <span class="button-name">Scale X</span>
                      </div>
                      <div class="button-container">
                        <div class="button-item">
                          <v-btn icon @click="settings.outlineScaleY -= 0.005, prepPrint()">
                            <v-icon>mdi-arrow-up</v-icon>
                          </v-btn>
                        </div>
                        <span class="button-name">{{this.settings.outlineScaleY.toFixed(4)}}</span>
                        <div class="button-item">
                          <v-btn icon @click="settings.outlineScaleY += 0.005, prepPrint()">
                            <v-icon>mdi-arrow-down</v-icon>
                          </v-btn>
                        </div>
                        <span class="button-name">Scale Y</span>
                      </div>
                    </v-list-group>
                    <v-list-group
                      no-action
                      sub-group
                      v-model="chipList"
                      @click="guideList = false"
                      :color="config.primary_text"
                    >
                      <template v-slot:activator>
                        <v-list-item-title>Chip Adjustment</v-list-item-title>
                      </template>
                        <div class="button-container">
                          <div class="button-item">
                            <v-btn icon @click="settings.offsetX += 0.01, prepPrint()">
                              <v-icon>mdi-arrow-left</v-icon>
                            </v-btn>
                          </div>
                          <span class="button-name">{{this.settings.offsetX.toFixed(4)}}</span>
                          <div class="button-item">
                            <v-btn icon @click="settings.offsetX -= 0.01, prepPrint()">
                              <v-icon>mdi-arrow-right</v-icon>
                            </v-btn>
                          </div>
                          <span class="button-name">Offset X</span>
                        </div>
                        <div class="button-container">
                          <div class="button-item">
                            <v-btn icon @click="settings.offsetY += 0.01, prepPrint()">
                              <v-icon>mdi-arrow-up</v-icon>
                            </v-btn>
                          </div>
                          <span class="button-name">{{this.settings.offsetY.toFixed(4)}}</span>
                          <div class="button-item">
                            <v-btn icon @click="settings.offsetY -= 0.01, prepPrint()">
                              <v-icon>mdi-arrow-down</v-icon>
                            </v-btn>
                          </div>
                          <span class="button-name">Offset Y</span>
                        </div>
                        <div class="button-container">
                          <div class="button-item">
                          <v-btn icon @click="settings.multiplier += 0.002, prepPrint()">
                            <v-icon>mdi-arrow-up</v-icon>
                          </v-btn>
                          </div>
                          <span class="button-name">{{this.settings.multiplier.toFixed(4)}}</span>
                          <div class="button-item">
                          <v-btn icon @click="settings.multiplier -= 0.002, prepPrint()">
                            <v-icon>mdi-arrow-down</v-icon>
                          </v-btn>
                          </div>
                          <span class="button-name">Space Multiplier</span>
                        </div>
                        <div class="button-container">
                          <div class="button-item">
                            <v-btn icon @click="settings.spaceOffsetX += 1, prepPrint()">
                              <v-icon>mdi-arrow-left</v-icon>
                            </v-btn>
                          </div>
                          <span class="button-name">{{this.settings.spaceOffsetX.toFixed(1)}}</span>
                          <div class="button-item">
                            <v-btn icon @click="settings.spaceOffsetX -= 1, prepPrint()">
                              <v-icon>mdi-arrow-right</v-icon>
                            </v-btn>
                          </div>
                          <span class="button-name">Space Offset X</span>
                        </div>
                        <div class="button-container">
                          <div class="button-item">
                            <v-btn icon @click="settings.spaceOffsetY += 1, prepPrint()">
                              <v-icon>mdi-arrow-up</v-icon>
                            </v-btn>
                          </div>
                          <span class="button-name">{{this.settings.spaceOffsetY.toFixed(1)}}</span>
                          <div class="button-item">
                            <v-btn icon @click="settings.spaceOffsetY -= 1, prepPrint()">
                              <v-icon>mdi-arrow-down</v-icon>
                            </v-btn>
                          </div>
                          <span class="button-name">Space Offset Y</span>
                        </div>
                    </v-list-group>
                  </v-list-group>
                </v-list>
                <v-list dark class="list-inside-2">
                  <v-list-group id="select-individual" :style="'background-color:'+config.secondary" :color="config.secondary_text" v-model="printList" @click="advancedList = false" prepend-icon="mdi-circle">
                    <template v-slot:activator>
                      <v-list-item-title>Select Individual</v-list-item-title>
                    </template>
                    <v-card tile flat>
                      <div class="toggle-container" >
                        <button class="toggle-button"
                          :key="index"
                          v-for="(number, index) in settings.amount"
                          @click="toggleNumber(number - 1)"
                        >
                          <v-icon v-if="ignoreList.includes(number - 1)" :color="config.alert">mdi-close</v-icon>
                          <v-icon v-if="!ignoreList.includes(number - 1)" :color="config.primary">mdi-circle</v-icon>
                        </button>
                      </div>
                    </v-card>
                    <v-card tile>
                      <v-card-subtitle>
                        {{70 - ignoreList.length}} / {{settings.amount}} Chips selected
                      </v-card-subtitle>
                    </v-card>
                  </v-list-group>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </div>
    </div>
  </v-card>
</template>

<script>
import config from '@/config/config'
import { fabric } from 'fabric'

export default {
  name: 'fsmodal',
  data () {
    return {
      prepPrintLoading: false,
      loading: false,
      advancedList: false,
      printList: true,
      ignoreList: [],
      chipList: false,
      guideList: false,
      config,
      prepCanvas: {},
      previewCanvas: null,
      configs: ['High Resolution - 0.9in'],
      currentConfig: 'High Resolution - 0.9in',
      settings: {
        resolutionScale: 3.0,
        marginScale: 0.0,
        multiplier: 1.0000,
        chipScale: 0.476,
        offsetX: 0.036,
        offsetY: -0.0600,
        spaceOffsetX: 0.0,
        spaceOffsetY: 0.0,
        amount: 70,
        outlineOffsetX: -4.00,
        outlineOffsetY: -8.00,
        outlineScale: 1.000,
        outlineScaleX: 1.000,
        outlineScaleY: 1.000
      },
      outlines: [
        require('@/assets/outline.png'),
        require('@/assets/outline2.png'),
        require('@/assets/outline3.png')
      ],
      chosenOutline: 0,
      defaultConfig: [
        {
          resolutionScale: 3.0,
          marginScale: 0.0,
          multiplier: 1.0000,
          chipScale: 0.476,
          offsetX: 0.036,
          offsetY: -0.0600,
          spaceOffsetX: 0.0,
          spaceOffsetY: 0.0,
          amount: 70,
          outlineOffsetX: -4.00,
          outlineOffsetY: -8.00,
          outlineScale: 1.000,
          outlineScaleX: 1.000,
          outlineScaleY: 1.000
        }
      ]
    }
  },
  methods: {
    async resetAdjust() {
      const newConfig = {...this.defaultConfig[0]}
      this.settings = newConfig
      this.prepPrint()
    },
    async toggleHalf(half) {
      let array = new Array
      this.previewCanvas.getObjects().forEach(element => {
        element.set('opacity', 0)
      })
      this.previewCanvas.renderAll()
      if (half == 'top') {
        let i
        for (i=0; i < this.settings.amount / 2; i++) {
          array.push(i + 35)
          this.previewCanvas.getObjects()[i].set('opacity', 1)
          this.previewCanvas.renderAll()
        }
        this.ignoreList = array
      } else if (half == 'bottom') {
        let i
        for (i=0; i < this.settings.amount / 2; i++) {
          array.push(i)
          this.previewCanvas.getObjects()[i + 35].set('opacity', 1)
          this.previewCanvas.renderAll()
        }
        this.ignoreList = array
      } else if (half == 'all') {
        this.ignoreList = array
        this.previewCanvas.getObjects().forEach(element => {
          element.set().set('opacity', 1)
        });
        this.previewCanvas.renderAll()
      } else if (half == 'none') {
        let i
        for (i=0; i < this.settings.amount; i++) {
          array.push(i)
          this.previewCanvas.getObjects()[i].set('opacity', 0)
          this.previewCanvas.renderAll()
        }
        this.ignoreList = array
      }
    },
    toggleNumber(number) {
      if (this.ignoreList.includes(number)) {
        this.ignoreList.splice(this.ignoreList.indexOf(number),1)
        this.previewCanvas.getObjects()[number].set('opacity', 1)
        this.previewCanvas.renderAll()
      }
      else {
        this.ignoreList.push(number)
        this.previewCanvas.getObjects()[number].set('opacity', 0)
        this.previewCanvas.renderAll()
      }
    },
    selectPreset () {
      switch (this.currentConfig) {
        case 'High Resolution - 0.9in':
          this.settings = this.defaultConfig[0];
          this.prepPrint()
          break
      }
      this.renderCanvas(false, 700);
    },
    async addGuide (canvas) {
      return new Promise ((resolve, reject) => {
        const outlines = this.outlines
        const chosenOutline = this.chosenOutline
        const outlineOffsetX = this.settings.outlineOffsetX
        const outlineOffsetY = this.settings.outlineOffsetY
        const outlineScale = this.settings.outlineScale
        const outlineScaleX = this.settings.outlineScaleX
        const outlineScaleY = this.settings.outlineScaleY
        canvas.setOverlayImage(outlines[chosenOutline], function (img, error) {
          if (error) {
            reject(error)
          }
          resolve(img)
        }, {
          centeredScaling: true,
          originX: 'center',
          originY: 'center',
          crossOrigin: 'anonymous',
          width: canvas.width * outlineScale * outlineScaleX,
          height: canvas.height * outlineScale * outlineScaleY,
          left: (canvas.width / 2) + outlineOffsetX,
          top: (canvas.height / 2) - outlineOffsetY
        });
      })
    },
    async addImage (uri, x, y, invisible) {
      return new Promise((resolve) => {
        const settings = this.settings
        let canvas = this.prepCanvas
        let opacity = 1.0
        if (invisible) {
          opacity = 0.0
        }
        new fabric.Image.fromURL(uri, function (oImg) {
          oImg.set({
            centeredScaling: true,
            originX: 'center',
            originY: 'center',
            left: x,
            top: y,
            selectable: false,
            opacity
          })
          oImg.scale(settings.chipScale)
          canvas.add(oImg)
          resolve(oImg)
        }, { crossOrigin: 'Anonymous' });
      })
    },
    async renderCanvas (print, pixelHeight) {
      const aspectRatio = this.prepCanvas.width / this.prepCanvas.height
      const scale = pixelHeight / this.prepCanvas.height
      if (print) {
        this.openPage(this.settings.resolutionScale)
      } else {
        if (!this.previewCanvas) {
          this.previewCanvas = await new fabric.StaticCanvas('p')
          this.previewCanvas.setWidth(aspectRatio * pixelHeight)
          this.previewCanvas.setHeight(pixelHeight)
          this.previewCanvas.setZoom(scale);
          await this.previewCanvas.loadFromJSON(this.prepCanvas.toDatalessJSON())
        } else {
          await this.previewCanvas.loadFromJSON(this.prepCanvas.toDatalessJSON())
        }
      }
    },
    async prepPrint () {
      if (this.prepPrintLoading == true) return null
      this.prepPrintLoading = true
      this.prepCanvas = new fabric.StaticCanvas
      this.prepCanvas.setWidth(850 * this.settings.resolutionScale)
      this.prepCanvas.setHeight(1100 * this.settings.resolutionScale)
      const totalX = 850 * this.settings.resolutionScale
      const totalY = 1100 * this.settings.resolutionScale
      const boxX = (660 + this.settings.spaceOffsetX) * this.settings.resolutionScale * this.settings.multiplier
      const boxY = (910 + this.settings.spaceOffsetY) * this.settings.resolutionScale * this.settings.multiplier
      const differenceX = totalX - boxX
      const differenceY = totalY - boxY
      const baseDistanceX = differenceX / (2 + this.settings.offsetX) 
      const baseDistanceY = differenceY / (2 + this.settings.offsetY)
      const stickerSpaceX = boxX / 6
      const stickerSpaceY = boxY / 9
      let centerPosY = baseDistanceY
      let centerPosX = baseDistanceX
      let i
      const uri = this.canvas_data
      for (i=0; i < this.settings.amount; i++) {
        let isIgnored = await this.ignoreList.some(index => index == i)
        if (!isIgnored) {
          await this.addImage(uri, centerPosX, centerPosY)
        } else {
          await this.addImage(uri, centerPosX, centerPosY, true)
        }
        if (Math.round(centerPosX) >= Math.round(stickerSpaceX * 6 + baseDistanceX)) {
          centerPosX = baseDistanceX
          centerPosY += stickerSpaceY
        } else {
          centerPosX += stickerSpaceX
        }
      }
      await this.addGuide(this.prepCanvas)
      this.renderCanvas(false, 700)
      return this.prepPrintLoading = false
    },
    async startPrint () {
      this.loading = true
      this.prepCanvas = new fabric.StaticCanvas
      this.prepCanvas.setWidth(850 * this.settings.resolutionScale)
      this.prepCanvas.setHeight(1100 * this.settings.resolutionScale)
      const totalX = 850 * this.settings.resolutionScale
      const totalY = 1100 * this.settings.resolutionScale
      const boxX = 660 * this.settings.resolutionScale * this.settings.multiplier
      const boxY = 910 * this.settings.resolutionScale * this.settings.multiplier
      const differenceX = totalX - boxX
      const differenceY = totalY - boxY
      const baseDistanceX = differenceX / (2 + this.settings.offsetX) 
      const baseDistanceY = differenceY / (2 + this.settings.offsetY)
      const stickerSpaceX = boxX / 6
      const stickerSpaceY = boxY / 9
      let centerPosY = baseDistanceY
      let centerPosX = baseDistanceX
      let i
      const uri = await this.canvas_data
      for (i=0; i < this.settings.amount; i++) {
        let isIgnored = await this.ignoreList.some(index => index == i)
        if (!isIgnored) {
          await this.addImage(uri, centerPosX, centerPosY)
        } else {
          await this.addImage(uri, centerPosX, centerPosY, true)
        }
        if (Math.round(centerPosX) >= Math.round(stickerSpaceX * 6 + baseDistanceX)) {
          centerPosX = baseDistanceX
          centerPosY += stickerSpaceY
        } else {
          centerPosX += stickerSpaceX
        }
      }
      this.renderCanvas(true)
    },
    openPage(scale) {
      this.loading = false
      const print_page = this.prepCanvas.toDataURL('image/png')
      const popup = window.open()
      popup.document.open()
      popup.document.write(this.htmlImage(print_page, scale))
    },
    htmlImage(source) {
      return `<html><head><style>@page { margin: 0mm; }</style><script>` +
      `function step1() {setTimeout("step2()", 400);}funct` + 
      `ion step2() { window.print();window.close();}` +
      `step1()` +
      `</scri` + 
      `pt></head><body style="margin: 0; padding: 0;" onlo` +
      `ad="step1()"><img style="width: 8.5in; height: 11in;" src="${source}"></body></html>`
    }
  },
  props: {
    canvas_data: String
  },
  components: {
  },
  watch: {
    currentConfig: function () {
      this.selectPreset()
    },
    canvas_data: function () {
      this.prepPrint()
    }
  },
  computed: {
  },
  mounted() {
    this.prepPrint()
  }
}
</script>

<style scoped>
  .button-container {
    background: rgb(77, 77, 77);
    height: 50px;
    width: 100%;
    overflow: visible;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
  }

  .button-container-main {
    height: 50px;
    width: 100%;
    overflow: visible;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
  }

  .button-item {
    margin: auto;
  }

  .button-name {
    font-weight: bold;
    width: auto;
    overflow: visible;
    white-space: nowrap;
    margin: auto;
  }

  .flex-container {
    height: 100%;
    width: 100%;
    margin: auto;
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    align-content: flex-start;
  }

  .adjust-element {
    width: 700px;
    height: 100%;
    order: 0;
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: flex-end;
    overflow: hidden;
    word-wrap: break-word;
    padding: none;
  }

  .settings-card {
    width: 90%;
    height: 90%;
    margin: auto;
    margin-top: 12px;
  }

  .preview-canvas {
    margin-right: auto;
  }

  .toggle-container {
    position: relative;
    height: 400px;
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: flex-start;
    align-content: flex-start;
  }

  .toggle-button {
    width: 14.285714%;
    height: 10%;
  }

  .list-inside {
    background: none;
  }

  .list-inside-2 {
    background: none;
  }

  #main-card {
    background: tomato;
  }

  #select-individual {
    max-width: 280px;
  }

  #left-side {
    background: rgb(255, 255, 255);
    width: auto;
    height: auto;
  }

  #right-side {
    margin-top: 12px;
    margin-right: 12px;
    margin-left: 12px;
  }

  @page { size:8.5in 11in;  margin: 0mm; }
</style>